import { Modal, Row } from 'antd';
import React, { ReactElement, useEffect } from 'react';
import { ReactComponent as RoundTickIcon } from '../../../assets/images/svg/round_tick_fill_success.svg';
import { GUTTOR_SPACE } from '../../constants/commonConstants';

const SuccessModal = (props: any): ReactElement => {
  const {isVisible, setIsVisible, successModalText} = props;

  useEffect((): any => {
    setTimeout((): any => {
      setIsVisible(false);
    }, 5000);
  }, []);

  return (<Modal
    visible={isVisible}
    footer={null}
    className="flex flex-element justify-center align-center shared-success-modal"
    onCancel={(): any => setIsVisible(false)}>
    <div className="flex flex-element flex-col file-container">
      <div>
        <Row gutter={GUTTOR_SPACE} justify="center" className="mb-sm">
          <strong><RoundTickIcon className="fill-success" /></strong>
        </Row>
        <Row gutter={GUTTOR_SPACE} justify="center" className="mb-sm">
          <strong>{successModalText}</strong>
        </Row>
      </div>
    </div>
  </Modal>);
};

export default SuccessModal;
